import axios, { AxiosResponse } from 'axios';
import { action, atom, onMount } from 'nanostores';
import {
  Experiment,
  ExperimentService,
  CreateExperimentRequest,
  ExperimentAssignment,
} from '../api';


export const $loadingExperiments = atom<boolean>(false);

export const $experiment = atom<Experiment | undefined>();

export const $experiments = atom<Experiment[]>([]);


/**
 * Main function to load score logics.
 */
export const loadExperiments = async (organizationId: string) => {
  console.log('Retrieving experiments ...');
  $loadingExperiments.set(true); // Set loading state to true
  await ensureOrganization(organizationId);

  var response = await ExperimentService.getExperiments(organizationId);
  $experiments.set(response ?? []);

  $loadingExperiments.set(false); // Set loading state back to false
};

export const createExperiment = action(
    $experiment,
    'createExperiment',
    async (
      store,
      organizationId: string,
      name: string,
      workflowIds: string[],
      startDate: string,
      endDate: string | null,
      accountReceivablesIds: string[],
      variantNames: string[],  
    ) => {
      const request: CreateExperimentRequest = {
        name: name,
        workflowIds: workflowIds,
        startDate: startDate,
        endDate: endDate ?? null,
        accountReceivablesIds: accountReceivablesIds,
        variantNames: variantNames,
      };
      const response = await ExperimentService.createExperiment(organizationId, request);
  
      if (!response) {
        return response;
      }
  
      $experiment.set(response);
  
      $experiments.set([response, ...$experiments.get()]);
      return response;
    },
  );

export const getExperiment = action(
  $experiment,
  'getExperiment',
  async (store, experimentId: string, organizationId: string | undefined) => {
    if (organizationId == undefined) {
      return;
    }

    const response = await ExperimentService.getExperiment(experimentId, organizationId);

    $experiment.set(response);
  },
);

// export const updateExperiment = action(
//   $experiment,
//   'updateExperiment',
//   async (store, experimentId: string, organizationId: string | undefined) => {
//     if (organizationId == undefined) {
//       return;
//     }

//     const response = await ExperimentService.updateExperiment(experimentId, organizationId);

//     $experiment.set(response);  
//   },
// );


export const deleteExperiment = action(
    $experiment,
    'deleteExperiment',
    async (store, experimentId: string, organizationId: string | undefined) => {
      if (organizationId == undefined) {
        return;
      }

      await ExperimentService.deleteExperiment(organizationId, experimentId);
  
      $experiment.set(undefined);
  
      // Splice out the experiment
      const experiments = $experiments.get();
  
      const index = experiments.findIndex(p => p.id === experimentId);
  
      if (index > -1) {
        experiments.splice(index, 1);
  
        $experiments.set(experiments);
      }
    },
  );
  


/**
 * Watch for route changes; if we haven't loaded the score logics, we try to load them.
 */
route.subscribe(async name => {
  // Add a small delay to ensure state is settled

  if (name !== 'experiment' || ($experiments.value?.length ?? 0) > 0) {
    return;
  }

  const params = $router.get()?.params as Record<'organizationId', string>;
  await loadExperiments(params.organizationId);
});


/**
 * Ensure that the indicator scores is loaded and selected.
 */
export const ensureExperiment = action(
  $experiment,
  'ensureExperiment',
  async (store, experimentId: string) => {
    let experiment: Experiment | undefined;

    const params = $router.get()?.params as Record<'organizationId', string>;
    
    if ($experiments.get().length === 0) {
      const experiments = await ExperimentService.getExperiments(
        params.organizationId ?? '',
      );

      $experiments.set(experiments);
      experiment = experiments.find(p => p.id === experimentId);
    } else {
      experiment = $experiments.get().find(p => p.id === experimentId);
    }
    

    $experiment.set(experiment);
  },
);  